import Head from 'next/head';
import PropTypes from 'prop-types';
import React from 'react';
import { parseRichSnippets } from '../../../helpers/richSnippets';

const RichSnippets = ({ deal, productId, pdtUrl, productDetails }) => {
  const snippet = parseRichSnippets(deal, productId, pdtUrl, productDetails);
  if (snippet) {
    return (
      <Head>
        <script
          dangerouslySetInnerHTML={{ __html: snippet }}
          key="google-snippet"
          type="application/ld+json"
        />
      </Head>
    );
  } else {
    return null;
  }
};

RichSnippets.propTypes = {
  deal: PropTypes.object,
  pdtUrl: PropTypes.string,
  productDetails: PropTypes.object,
  productId: PropTypes.string,
};

RichSnippets.defaultProps = {
  deal: null,
  pdtUrl: null,
  productDetails: null,
  productId: null,
};

export default RichSnippets;
